import { render, staticRenderFns } from "./BaseSearchClient.vue?vue&type=template&id=641a083a"
import script from "./BaseSearchClient.vue?vue&type=script&lang=js"
export * from "./BaseSearchClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports